import React from 'react';
import PropTypes from 'prop-types';

/**
 * InputGroup component with Tailwind CSS — replaces react-bootstrap InputGroup.
 * Visually joins addons, inputs, and buttons: inner corners squared, borders collapsed.
 *
 * Works with children that carry their own border + rounding (raw input, TwInput,
 * Button, IconButton, InputGroup.Text). FormInput wraps its input in extra divs,
 * so use a raw input or TwInput inside a group instead.
 *
 * Usage:
 *   <InputGroup>
 *     <InputGroup.Text><FaSearch /></InputGroup.Text>
 *     <input className="..." />
 *     <Button>Search</Button>
 *   </InputGroup>
 */
const JOIN_CLASSES =
  '[&>*:not(:first-child)]:tw-rounded-l-none [&>*:not(:last-child)]:tw-rounded-r-none [&>*:not(:first-child)]:tw--ml-px';

const InputGroup = ({ children, className = '', ...props }) => (
  <div className={`tw-flex tw-items-stretch tw-w-full ${JOIN_CLASSES} ${className}`} {...props}>
    {children}
  </div>
);

/** Static addon segment (icon or text) rendered flush with the neighbouring input. */
const Text = ({ children, className = '' }) => (
  <span
    className={`tw-inline-flex tw-items-center tw-px-3 tw-text-sm tw-text-slate-500 tw-bg-slate-50 tw-border tw-border-solid tw-border-slate-300 tw-rounded-md ${className}`}
  >
    {children}
  </span>
);

Text.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

InputGroup.Text = Text;

InputGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default InputGroup;
